module.exports = __webpack_public_path__ + "static/media/eva_calendar-outline-yesterday.4d70e869.svg";